import { Action } from 'redux'
import { cartItemSchema } from '../../events'
import { z } from 'zod'
import { sswSubscriptionPackageSchema } from '../ssw/ssw-subscription-types'

const subscriptionPromptCookieDataSchema = z.object({
    href: z.string(),
    time: z.number(),
    package_info: z
        .object({
            item_id: z.string().optional().nullable(),
            item_name: z.string().optional().nullable(),
            item_brand: z.string().optional().nullable(),
            is_offer: z.boolean().optional().default(false),
            price: z.number().optional().nullable(),
            promo_price: z.number().optional().nullable(),
            discount: z.number().optional().nullable(),
            coupon: z.string().optional().nullable(),
            quantity: z.number(),
            package: sswSubscriptionPackageSchema,
            cart_payload: z.array(cartItemSchema),
        })
        .optional(),
})

export type SubscriptionPromptCookieData = z.infer<
    typeof subscriptionPromptCookieDataSchema
>

export const isCookieValidSubscriptionPromptCookie = (
    rawCookie: string | undefined,
): SubscriptionPromptCookieData | false => {
    if (!rawCookie) {
        return false
    }

    // Firstly attempt to parse the cookie value as JSON
    try {
        const parsed = JSON.parse(rawCookie)
        return subscriptionPromptCookieDataSchema.parse(parsed)
    } catch (error) {
        console.warn(
            { error },
            'Subscription prompt cookie data is invalid or corrupted.',
        )

        return false
    }
}

// State object used to keep track of miscellaneous information
export interface MiscellaneousState {
    baySeed?: string // Used as the seed value for the randomisation function inside the best-austarlian-yarn initiative
}

const SET_BAYSEED_VAL = 'SET_BAYSEED_VAL'

export interface SET_BAYSEED_VAL_ACTION extends Action {
    type: typeof SET_BAYSEED_VAL
    payload: { seedVal: string }
}

export const setBaySeedVal = (val: string) => ({
    type: SET_BAYSEED_VAL,
    payload: {
        seedVal: val,
    },
})

export const miscellaneousReducer = (
    state: MiscellaneousState = {
        baySeed: undefined,
    },
    action: SET_BAYSEED_VAL_ACTION | { type: '@@INIT' },
) => {
    switch (action.type) {
        case SET_BAYSEED_VAL:
            return { ...state, baySeed: action.payload.seedVal }
        default:
            return {
                ...state,
            }
    }
}
